module.exports = __webpack_public_path__ + "static/moego-hero-8e7f40964ad5da94b722b63e0d595ad4.png";